var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic:baseline-keyboard-voice"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 15.5C13.66 15.5 14.99 14.16 14.99 12.5L15 6.5C15 4.84 13.66 3.5 12 3.5C10.34 3.5 9 4.84 9 6.5V12.5C9 14.16 10.34 15.5 12 15.5ZM17.3 12.5C17.3 15.5 14.76 17.6 12 17.6C9.24 17.6 6.7 15.5 6.7 12.5H5C5 15.92 7.72 18.73 11 19.22V22.5H13V19.22C16.28 18.74 19 15.92 19 12.5H17.3Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMic);
export default __webpack_public_path__ + "static/media/mic.b740da5accf35e9fcbe5a1917d3cf19c.svg";
export { ForwardRef as ReactComponent };